module.exports = require("@material/checkbox/dist/mdc.checkbox");


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/checkbox/dist/mdc.checkbox","commonjs2":"@material/checkbox/dist/mdc.checkbox","commonjs":"@material/checkbox/dist/mdc.checkbox","amd":"@material/checkbox/dist/mdc.checkbox","umd":"@material/checkbox/dist/mdc.checkbox"}
// module id = 23
// module chunks = 0